import AppStore from "./AppStore";
import { buildClassName } from "./util";

// id: "20bd56bf-0247-4c6a-a2ef-8853a77ccd48"
// title: "Members Header"
// type: :reference
// key: "header"
// parent_id: nil
export function Header20bd56bf02474c6aA2ef8853a77ccd48(props: any) {
  return (
    <MembersAreaHeaderOldD13a9264561d4703Beb4B4f6b4a13cf8 parentTag="Header20bd56bf02474c6aA2ef8853a77ccd48" {...props} />
  );
}

// id: "ae3e5461-b3d2-46f2-bc5b-2a0a85c53e8c"
// title: "Resources Page"
// type: :reference
// key: "resources-page"
// parent_id: nil
export function ResourcesPageAe3e5461B3d246f2Bc5b2a0a85c53e8c(props: any) {
  return (
    <SecondaryPage2443939a735146eaBf30C09d2d282a72 parentTag="ResourcesPageAe3e5461B3d246f2Bc5b2a0a85c53e8c" header={<SecondaryMarketingHeader0f2a2c8d60914b5cB31c7e70ef5c119b parentTag="Header3166f77021da41bbA4dc9380e15e6290" title="Resources" />} {...props} />
  );
}

// id: "7c5584b4-90ad-41b0-90c4-f9b144bbfae5"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "429e88c1-5ea6-4e02-900d-7e69535861fb"
export function Footer7c5584b490ad41b090c4F9b144bbfae5(props: any) {
  return (
    <DefaultFooter6ec2bf20Eb6e4ddbB47c00e98493a579 parentTag="Footer7c5584b490ad41b090c4F9b144bbfae5" {...props} />
  );
}

// id: "8ddcd4ed-8811-418a-9b0f-f9b1f77fd202"
// title: ""
// type: :text
// key: "alt"
// parent_id: "82b71e19-94ac-4b17-b376-9936194f836c"
export const Alt8ddcd4ed8811418a9b0fF9b1f77fd202 = "logo";

// id: "723ec82b-d147-44ed-ae43-3566b074a67e"
// title: ""
// type: :html
// key: "about-susan-main"
// parent_id: "4447c32f-e617-41d8-a8bc-55461b6fb689"
export function AboutSusanMain723ec82bD14744edAe433566b074a67e(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <main className={`${parentTag || ""} AboutSusanMain723ec82bD14744edAe433566b074a67e`}>
      <div className="background-image">
      </div>
      <div className="text-block first">
        <div className="opacity">
        </div>
        <div className="text">
          <h2 className="heading">
            Welcome to the house of Breath.
          </h2>
          <p>
            Here we can slow down, exhale the old, and breathe in the new.
          </p>
          <p>
            Are you looking for deeper ways to connect with yourself?
          </p>
          <p>
            Do you feel desire to experience MORE?
          </p>
          <p>
            More...
          </p>
          <p>
            pleasure, security, magic, wholeness...
          </p>
          <p>
            MORE TURNED ON WITH YOUR LIFE.
          </p>
          <p>
            Answer the beckoning of the heart,
          </p>
          <p>
            I&#39;m here to support you on this journey.
          </p>
        </div>
      </div>
      <div className="page-row color-scheme-1">
        <div className="text-block centered-page-content">
          <div className="text">
            <p className="heading">
              Discover the magic you behold
            </p>
            <p>
              When we get overwhelmed by life and navigate difficult situations, we
              can forget our own magic. Sometimes we are shut down and disconnected
              from our body, our pleasure, our purpose.
            </p>
            <p>
              It&#39;s okay to ask for help, it&#39;s my honor to help remind you. Let&#39;s
              take time to build trust and learn about what you are missing.
            </p>
            <p>
              Sacred space gives us an opportunity to loosen up tension in the body.
              Clear out old chakra patterns. Remember what it feels like to be your
              magical integrated self.
            </p>
            <p>
              House of Breath is a Temple. Serene, sensual, playful.
            </p>
            <div className="button-container">
              <a href="/about/offerings" className="Button transition">
                Explore my Offerings
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="image-block">
      </div>
      <div className="page-row color-scheme-1">
        <div className="text-block centered-page-content testimonials">
          <div className="heading">
            Testimonials
          </div>
          <div className="testimonial">
            <div className="image-container">
              <img src="https://mp1md-pub.s3.amazonaws.com/orgs/tastesoftantra/images/Shout.jpg" alt="photo of CK" />
            </div>
            <div className="text-container">
              <p>
                I felt a warm, tight feeling in my throat as Susan was working on
                opening my throat chakra. I thought of people who I let take my
                voice away and my inner self said &quot;NO MORE, This is my voice, I will
                speak my truth&quot;
              </p>
              <p>
                — CK
              </p>
            </div>
            <div className="bottom" />
          </div>
          <div className="testimonial">
            <div className="image-container">
              <img src="https://mp1md-pub.s3.amazonaws.com/orgs/tastesoftantra/images/Relaxation.jpeg" alt="photo of BB" />
            </div>
            <div className="text-container">
              <p>
                She has a loving intuition that meets you where you are. She helps
                you relax into healing yourself while allowing the possibilities of
                what your life can be to blossom.
              </p>
              <p>
                — BB
              </p>
            </div>
            <div className="bottom" />
          </div>
          <div className="testimonial">
            <div className="image-container">
              <img src="https://mp1md-pub.s3.amazonaws.com/orgs/tastesoftantra/images/Touch.jpg" alt="photo of CK" />
            </div>
            <div className="text-container">
              <p>
                Through her touch, Susan makes a visceral connection that reaches my
                core, sending reverberations throughout my body.
              </p>
              <p>
                — R
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="contact-small">
      </div>
      <div className="contact-container">
        <div className="contact-form block color-scheme-2">
          <div className="heading">
            Reach out for a free consultation!
          </div>
          <p>
            When you feel called to any of my services, it begins with a discovery
            call with SuSun. This is to make sure Tastes of Tantra is a good fit for
            yourself and your relationships!
          </p>
          <div className="button-container">
            <a href="/members/messages/x1RwUD7TogtZzODN" className="Button color2 transition">
              Message SuSun
            </a>
          </div>
        </div>
        <div className="image">
        </div>
      </div>
    </main>
  );
}

// id: "b6d1a0ff-ec4c-4a44-b894-9690c79ee760"
// title: ""
// type: :text
// key: "title"
// parent_id: "ba92426c-d601-47cb-9467-2a78b69c6788"
export const TitleB6d1a0ffEc4c4a44B8949690c79ee760 = "Leveling";

// id: "635159c1-c0c8-44b6-b072-936875fbe716"
// title: "HREF"
// type: :text
// key: "href"
// parent_id: nil
export const Href635159c1C0c844b6B072936875fbe716 = "/";

// id: "8089b3d7-97d5-4dab-8b16-b98321436fc7"
// title: "Title - Leveling"
// type: :text
// key: "title"
// parent_id: nil
export const Title8089b3d797d54dab8b16B98321436fc7 = "Leveling";

// id: "c622f898-f16e-42c4-a101-b5ab8e020367"
// title: ""
// type: :gf_preset
// key: "hero"
// parent_id: "72577776-1829-4990-9a88-3c9e38439f51"
export function HeroC622f898F16e42c4A101B5ab8e020367(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Hero className="HeroC622f898F16e42c4A101B5ab8e020367" parentTag={buildClassName("HeroC622f898F16e42c4A101B5ab8e020367", parentTag)} postSlug="home-hero" {...props} />
  );
}

// id: "9b1d7d29-bb90-4b57-b215-920289cea259"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "4447c32f-e617-41d8-a8bc-55461b6fb689"
export const NavMenuSlug9b1d7d29Bb904b57B215920289cea259 = "members-primary-nav";

// id: "7160c8de-4d25-4fbf-b003-0ef23b0b7e17"
// title: ""
// type: :reference
// key: "about-susan-header"
// parent_id: "3479e80c-54e8-4c69-9f15-6976e741eea8"
export function AboutSusanHeader7160c8de4d254fbfB0030ef23b0b7e17(props: any) {
  return (
    <MembersAreaHeaderOldD13a9264561d4703Beb4B4f6b4a13cf8 parentTag="AboutSusanHeader7160c8de4d254fbfB0030ef23b0b7e17" {...props} />
  );
}

// id: "ab0d78f4-00ed-4042-b0f3-6ce3365d73b0"
// title: ""
// type: :text
// key: "title"
// parent_id: "225006e4-0cb9-469a-8991-e571ab647a5f"
export const TitleAb0d78f400ed4042B0f36ce3365d73b0 = "About Susan";

// id: "429e88c1-5ea6-4e02-900d-7e69535861fb"
// title: "Member Pages"
// type: :html
// key: "member-pages-old"
// parent_id: nil
export function MemberPagesOld429e88c15ea64e02900d7e69535861fb(props: any) {
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const SecondaryNavigation = AppStore.presets["SecondaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} MemberPagesOld429e88c15ea64e02900d7e69535861fb`}>
      {props["header"] || <MembersAreaHeaderOldD13a9264561d4703Beb4B4f6b4a13cf8 parentTag="Header8250aac8042447f8913f6e665945b0aa" {...props} />}
      {props["secondary-nav"] || <SecondaryNavigation className="SecondaryNavCf21560b19404d58Bc744da88ab2bfdb" parentTag={buildClassName("SecondaryNavCf21560b19404d58Bc744da88ab2bfdb", parentTag)} {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooter6ec2bf20Eb6e4ddbB47c00e98493a579 parentTag="Footer7c5584b490ad41b090c4F9b144bbfae5" {...props} />}
    </div>
  );
}

// id: "e9514198-4473-4786-970e-57e4d9d0f1c5"
// title: "Home Page"
// type: :html
// key: "home-page"
// parent_id: nil
export function HomePageE951419844734786970e57e4d9d0f1c5(props: any) {
  const WelcomeBackPopUp = AppStore.presets["WelcomeBackPopUp"];
  const PageQuote = AppStore.presets["PageQuote"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HomePageE951419844734786970e57e4d9d0f1c5 page`}>
      {props["header"] || <HomeHeader72577776182949909a883c9e38439f51 parentTag="Header4e2082431f9e4e7eAefc5ff989662083" {...props} />}
      {props["welcome-back"] || <WelcomeBackPopUp className="WelcomeBack66647cb82b284552Bf7dD1e2db9947af" parentTag={buildClassName("WelcomeBack66647cb82b284552Bf7dD1e2db9947af", parentTag)} {...props} />}
      {props["body"] || <MarketingBody9d7fd95bC7014899B32f6c5055f77ef0 parentTag="Body02e5eef5238e4fc89ac84f0586d940f0" {...props} />}
      {props["quote"] || <PageQuote className="Quote12e1f4057eec4a60Baf3A6c3e00acd79" parentTag={buildClassName("Quote12e1f4057eec4a60Baf3A6c3e00acd79", parentTag)} contentSlug="home-page-quote" {...props} />}
      {props["footer"] || <DefaultFooter6ec2bf20Eb6e4ddbB47c00e98493a579 parentTag="FooterE29fb1347e5341b3Bd13Ef4a841f88ee" {...props} />}
    </div>
  );
}

// id: "ba92426c-d601-47cb-9467-2a78b69c6788"
// title: ""
// type: :reference
// key: "header"
// parent_id: "cb3923a0-602d-43e3-b227-3ddee5ba8381"
export function HeaderBa92426cD60147cb94672a78b69c6788(props: any) {
  return (
    <SecondaryMarketingHeader0f2a2c8d60914b5cB31c7e70ef5c119b parentTag="HeaderBa92426cD60147cb94672a78b69c6788" title="Leveling" {...props} />
  );
}

// id: "cf21560b-1940-4d58-bc74-4da88ab2bfdb"
// title: ""
// type: :gf_preset
// key: "secondary-nav"
// parent_id: "429e88c1-5ea6-4e02-900d-7e69535861fb"
export function SecondaryNavCf21560b19404d58Bc744da88ab2bfdb(props: any) {
  const SecondaryNavigation = AppStore.presets["SecondaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <SecondaryNavigation className="SecondaryNavCf21560b19404d58Bc744da88ab2bfdb" parentTag={buildClassName("SecondaryNavCf21560b19404d58Bc744da88ab2bfdb", parentTag)} {...props} />
  );
}

// id: "98e96486-9dc7-41a0-9b51-eb9f7b18ff34"
// title: ""
// type: :reference
// key: "header"
// parent_id: "76363eef-eb7b-4818-a5bc-e43ae90f6286"
export function Header98e964869dc741a09b51Eb9f7b18ff34(props: any) {
  return (
    <MembersAreaHeaderOldD13a9264561d4703Beb4B4f6b4a13cf8 parentTag="Header98e964869dc741a09b51Eb9f7b18ff34" navMenuSlug="members-primary-nav" {...props} />
  );
}

// id: "91917842-8857-4d89-9401-1812cab76b85"
// title: ""
// type: :reference
// key: "label"
// parent_id: "5bfd5525-011b-441c-93aa-30acc33ae133"
export function Label9191784288574d8994011812cab76b85(props: any) {
  return (
    <DefaultLogo82b71e1994ac4b17B3769936194f836c parentTag="Label9191784288574d8994011812cab76b85" {...props} />
  );
}

// id: "e12a3d48-d6f3-4063-ab0a-784bda71ac02"
// title: "Header Area Top"
// type: :html
// key: "default-header-top"
// parent_id: nil
export function DefaultHeaderTopE12a3d48D6f34063Ab0a784bda71ac02(props: any) {
  const Link = AppStore.presets["Link"];
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} DefaultHeaderTopE12a3d48D6f34063Ab0a784bda71ac02 header-top`}>
      {props["linked-logo"] || <Link className="LinkedLogo0d6b6d2291ba454a9acaF62cb30bd495" parentTag={buildClassName("LinkedLogo0d6b6d2291ba454a9acaF62cb30bd495", parentTag)} label={<DefaultLogo82b71e1994ac4b17B3769936194f836c parentTag="Label2bf815f2Bfea44c99858938b19d94a63" alt="logo" />} className="linked-logo" url="/" {...props} />}
      {props["navigation"] || <PrimaryNavigation className="Navigation2ccb86c180e54426Ad04Ebad5b654e89" parentTag={buildClassName("Navigation2ccb86c180e54426Ad04Ebad5b654e89", parentTag)} className="navigation" navMenuSlug="marketing-primary-nav" {...props} />}
    </div>
  );
}

// id: "b16c6ac4-5d59-4853-bfa6-a66fb970deaf"
// title: "Default Header Reference"
// type: :reference
// key: "default-header"
// parent_id: nil
export function DefaultHeaderB16c6ac45d594853Bfa6A66fb970deaf(props: any) {
  return (
    <SecondaryMarketingHeader0f2a2c8d60914b5cB31c7e70ef5c119b parentTag="DefaultHeaderB16c6ac45d594853Bfa6A66fb970deaf" title="Apply" navMenuSlug="marketing-primary-nav" {...props} />
  );
}

// id: "103d08a8-61f8-4a00-8c45-9e6ba31711bd"
// title: ""
// type: :gf_preset
// key: "button"
// parent_id: "dd301871-3284-4b9e-9716-cad73e7b98a4"
export function Button103d08a861f84a008c459e6ba31711bd(props: any) {
  const Button = AppStore.presets["Button"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Button className="Button103d08a861f84a008c459e6ba31711bd" parentTag={buildClassName("Button103d08a861f84a008c459e6ba31711bd", parentTag)} label="Join Us" href="/join" {...props} />
  );
}

// id: "7ac2223e-518d-42cd-a9c3-d95cacbe397b"
// title: ""
// type: :text
// key: "backgroundImage"
// parent_id: "72577776-1829-4990-9a88-3c9e38439f51"
export const BackgroundImage7ac2223e518d42cdA9c3D95cacbe397b = "https://mp1md-pub.s3.amazonaws.com/orgs/tastesoftantra/hero4.jpg";

// id: "9dac4e2b-c13f-4c2f-a72e-a80b68874e4b"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "6ad2bf4a-2bb1-4431-88b1-92725c364d23"
export function Footer9dac4e2bC13f4c2fA72eA80b68874e4b(props: any) {
  return (
    <DefaultFooter6ec2bf20Eb6e4ddbB47c00e98493a579 parentTag="Footer9dac4e2bC13f4c2fA72eA80b68874e4b" {...props} />
  );
}

// id: "f057e8f1-3d69-4095-a05f-a217a15f6aef"
// title: ""
// type: :text
// key: "title"
// parent_id: "de48a21e-eb3d-40c6-9d3e-e5d9365c83df"
export const TitleF057e8f13d694095A05fA217a15f6aef = "Secondary Page";

// id: "9d7fd95b-c701-4899-b32f-6c5055f77ef0"
// title: "Marketing Cards Body"
// type: :html
// key: "marketing-body"
// parent_id: nil
export function MarketingBody9d7fd95bC7014899B32f6c5055f77ef0(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} MarketingBody9d7fd95bC7014899B32f6c5055f77ef0 page-body`}>
      {props["marketingCards"] || <MarketingCardsFcbd50009aa24693853d49c54431fb8e parentTag="MarketingCardsCdb383e8Cdc04522953167dbfefbbf3c" postSlug="home-page-posts2" {...props} />}
    </div>
  );
}

// id: "e5b93beb-7dc3-4247-99da-708903df58df"
// title: "Label"
// type: :reference
// key: "label"
// parent_id: nil
export function LabelE5b93beb7dc3424799da708903df58df(props: any) {
  return (
    <DefaultLogo82b71e1994ac4b17B3769936194f836c parentTag="LabelE5b93beb7dc3424799da708903df58df" {...props} />
  );
}

// id: "647a6881-32f9-45a5-8d2d-8d6a685ffc10"
// title: ""
// type: :gf_preset
// key: "navigation"
// parent_id: "3627fd16-af04-4889-9796-8dabaf6a453f"
export function Navigation647a688132f945a58d2d8d6a685ffc10(props: any) {
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PrimaryNavigation className="Navigation647a688132f945a58d2d8d6a685ffc10" parentTag={buildClassName("Navigation647a688132f945a58d2d8d6a685ffc10", parentTag)} navMenuSlug="members-primary-nav" {...props} />
  );
}

// id: "cb3923a0-602d-43e3-b227-3ddee5ba8381"
// title: "Levels 1-4 Explained"
// type: :html
// key: "about-leveling-page"
// parent_id: nil
export function AboutLevelingPageCb3923a0602d43e3B2273ddee5ba8381(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AboutLevelingPageCb3923a0602d43e3B2273ddee5ba8381`}>
      {props["header"] || <SecondaryMarketingHeader0f2a2c8d60914b5cB31c7e70ef5c119b parentTag="HeaderBa92426cD60147cb94672a78b69c6788" title="Leveling" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooter6ec2bf20Eb6e4ddbB47c00e98493a579 parentTag="Footer072f23d36e5e4840Bc949e9f8be02355" {...props} />}
    </div>
  );
}

// id: "82b71e19-94ac-4b17-b376-9936194f836c"
// title: "Logo"
// type: :html
// key: "default-logo"
// parent_id: nil
export function DefaultLogo82b71e1994ac4b17B3769936194f836c(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <img src="https://mp1md-pub.s3.amazonaws.com/orgs/tastesoftantra/logo-wide-white.svg" className={`${parentTag || ""} DefaultLogo82b71e1994ac4b17B3769936194f836c logo`} alt="logo" />
  );
}

// id: "a807bce1-de4c-4210-8198-185446bd8740"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "2443939a-7351-46ea-bf30-c09d2d282a72"
export function FooterA807bce1De4c42108198185446bd8740(props: any) {
  return (
    <DefaultFooter6ec2bf20Eb6e4ddbB47c00e98493a579 parentTag="FooterA807bce1De4c42108198185446bd8740" {...props} />
  );
}

// id: "8578c327-6479-4b2e-bea8-b40628b6583a"
// title: ""
// type: :gf_preset
// key: "groupflow"
// parent_id: "6ec2bf20-eb6e-4ddb-b47c-00e98493a579"
export function Groupflow8578c32764794b2eBea8B40628b6583a(props: any) {
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupFlowTag className="Groupflow8578c32764794b2eBea8B40628b6583a" parentTag={buildClassName("Groupflow8578c32764794b2eBea8B40628b6583a", parentTag)} {...props} />
  );
}

// id: "a714ee57-78ab-4ebc-8687-a7a49cdb1dc6"
// title: ""
// type: :text
// key: "class"
// parent_id: "6ced6757-8fac-4360-9a15-84268d702014"
export const ClassA714ee5778ab4ebc8687A7a49cdb1dc6 = "join-us";

// id: "75b55a1c-a875-4698-ab6a-b76a77fa3466"
// title: ""
// type: :text
// key: "title"
// parent_id: "d59d85b2-c279-47d2-be7e-c4e84231ab7b"
export const Title75b55a1cA8754698Ab6aB76a77fa3466 = "Join Us";

// id: "bce3bc00-525c-44e9-936c-3160ca9411f1"
// title: "Signup Pages"
// type: :reference
// key: "signup-pages"
// parent_id: nil
export function SignupPagesBce3bc00525c44e9936c3160ca9411f1(props: any) {
  return (
    <SecondaryPage2443939a735146eaBf30C09d2d282a72 parentTag="SignupPagesBce3bc00525c44e9936c3160ca9411f1" header={<SecondaryMarketingHeader0f2a2c8d60914b5cB31c7e70ef5c119b parentTag="HeaderD59d85b2C27947d2Be7eC4e84231ab7b" title="Join Us" />} {...props} />
  );
}

// id: "9eae99eb-0aa0-482c-a8c6-2a7099f61960"
// title: "Common Footer"
// type: :reference
// key: "footer"
// parent_id: nil
export function Footer9eae99eb0aa0482cA8c62a7099f61960(props: any) {
  return (
    <DefaultFooter6ec2bf20Eb6e4ddbB47c00e98493a579 parentTag="Footer9eae99eb0aa0482cA8c62a7099f61960" {...props} />
  );
}

// id: "428a776e-bbd3-42c7-a510-507f0ad96b05"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "72577776-1829-4990-9a88-3c9e38439f51"
export function HeaderTop428a776eBbd342c7A510507f0ad96b05(props: any) {
  return (
    <DefaultHeaderTopE12a3d48D6f34063Ab0a784bda71ac02 parentTag="HeaderTop428a776eBbd342c7A510507f0ad96b05" {...props} />
  );
}

// id: "3166f770-21da-41bb-a4dc-9380e15e6290"
// title: ""
// type: :reference
// key: "header"
// parent_id: "ae3e5461-b3d2-46f2-bc5b-2a0a85c53e8c"
export function Header3166f77021da41bbA4dc9380e15e6290(props: any) {
  return (
    <SecondaryMarketingHeader0f2a2c8d60914b5cB31c7e70ef5c119b parentTag="Header3166f77021da41bbA4dc9380e15e6290" title="Resources" {...props} />
  );
}

// id: "de48a21e-eb3d-40c6-9d3e-e5d9365c83df"
// title: ""
// type: :reference
// key: "header"
// parent_id: "2443939a-7351-46ea-bf30-c09d2d282a72"
export function HeaderDe48a21eEb3d40c69d3eE5d9365c83df(props: any) {
  return (
    <SecondaryMarketingHeader0f2a2c8d60914b5cB31c7e70ef5c119b parentTag="HeaderDe48a21eEb3d40c69d3eE5d9365c83df" title="Secondary Page" {...props} />
  );
}

// id: "2bf815f2-bfea-44c9-9858-938b19d94a63"
// title: ""
// type: :reference
// key: "label"
// parent_id: "0d6b6d22-91ba-454a-9aca-f62cb30bd495"
export function Label2bf815f2Bfea44c99858938b19d94a63(props: any) {
  return (
    <DefaultLogo82b71e1994ac4b17B3769936194f836c parentTag="Label2bf815f2Bfea44c99858938b19d94a63" {...props} />
  );
}

// id: "116ea88f-0237-4ebc-9201-b97a136709e4"
// title: "Public Events Page"
// type: :html
// key: "public-events-page"
// parent_id: nil
export function PublicEventsPage116ea88f02374ebc9201B97a136709e4(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PublicEventsPage116ea88f02374ebc9201B97a136709e4`}>
      {props["header"] || <SecondaryMarketingHeader0f2a2c8d60914b5cB31c7e70ef5c119b parentTag="Header451857c022c14ab699ee2b3ca1dc8661" title="Public Events" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooter6ec2bf20Eb6e4ddbB47c00e98493a579 parentTag="Footer3a9c0bca86074a7293deBbc97b3fe438" {...props} />}
    </div>
  );
}

// id: "76363eef-eb7b-4818-a5bc-e43ae90f6286"
// title: "Members Area"
// type: :html
// key: "members-area-default"
// parent_id: nil
export function MembersAreaDefault76363eefEb7b4818A5bcE43ae90f6286(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} MembersAreaDefault76363eefEb7b4818A5bcE43ae90f6286 page`}>
      {props["header"] || <MembersAreaHeaderOldD13a9264561d4703Beb4B4f6b4a13cf8 parentTag="Header98e964869dc741a09b51Eb9f7b18ff34" navMenuSlug="members-primary-nav" {...props} />}
      {props["footer"] || <DefaultFooter6ec2bf20Eb6e4ddbB47c00e98493a579 parentTag="FooterA283fb68952d434cB91c6c9b63d94831" {...props} />}
    </div>
  );
}

// id: "d59d85b2-c279-47d2-be7e-c4e84231ab7b"
// title: ""
// type: :reference
// key: "header"
// parent_id: "bce3bc00-525c-44e9-936c-3160ca9411f1"
export function HeaderD59d85b2C27947d2Be7eC4e84231ab7b(props: any) {
  return (
    <SecondaryMarketingHeader0f2a2c8d60914b5cB31c7e70ef5c119b parentTag="HeaderD59d85b2C27947d2Be7eC4e84231ab7b" title="Join Us" {...props} />
  );
}

// id: "a742946d-ff44-4d1c-905e-9d124516e6e1"
// title: ""
// type: :gf_preset
// key: "links"
// parent_id: "6ec2bf20-eb6e-4ddb-b47c-00e98493a579"
export function LinksA742946dFf444d1c905e9d124516e6e1(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Navigation className="LinksA742946dFf444d1c905e9d124516e6e1" parentTag={buildClassName("LinksA742946dFf444d1c905e9d124516e6e1", parentTag)} navMenuSlug="footer-nav" {...props} />
  );
}

// id: "cf11e3ea-5896-490f-adc8-7a353b8badca"
// title: "Secondary Marketing Hero"
// type: :html
// key: "secondary-marketing-hero"
// parent_id: nil
export function SecondaryMarketingHeroCf11e3ea5896490fAdc87a353b8badca(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHeroCf11e3ea5896490fAdc87a353b8badca hero`}>
      <div className="title">
        {props["title"] || Title8a1cc72a433340a883364a1b7d55d7eb}
      </div>
    </div>
  );
}

// id: "6ec2bf20-eb6e-4ddb-b47c-00e98493a579"
// title: "Footer"
// type: :html
// key: "default-footer"
// parent_id: nil
export function DefaultFooter6ec2bf20Eb6e4ddbB47c00e98493a579(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <footer className={`${parentTag || ""} DefaultFooter6ec2bf20Eb6e4ddbB47c00e98493a579 footer`}>
      {props["links"] || <Navigation className="LinksA742946dFf444d1c905e9d124516e6e1" parentTag={buildClassName("LinksA742946dFf444d1c905e9d124516e6e1", parentTag)} navMenuSlug="footer-nav" {...props} />}
      <div className="logo-wrapper">
        {props["logo"] || <Logo02923805132442268e02D83ef87c1ebe />}
      </div>
      {props["copyright"] || <GroupCopyright className="Copyright1b42632b5b124a5d890aD2ccfd12dcf8" parentTag={buildClassName("Copyright1b42632b5b124a5d890aD2ccfd12dcf8", parentTag)} {...props} />}
      {props["groupflow"] || <GroupFlowTag className="Groupflow8578c32764794b2eBea8B40628b6583a" parentTag={buildClassName("Groupflow8578c32764794b2eBea8B40628b6583a", parentTag)} {...props} />}
    </footer>
  );
}

// id: "f2c06cfa-4c78-406c-ad51-e4449fa6213a"
// title: ""
// type: :text
// key: "title"
// parent_id: "0f2a2c8d-6091-4b5c-b31c-7e70ef5c119b"
export const TitleF2c06cfa4c78406cAd51E4449fa6213a = "Secondary Marketing Title 1";

// id: "96a33822-6e12-4a97-b138-ee2ede8d965b"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "fcbd5000-9aa2-4693-853d-49c54431fb8e"
export const PostSlug96a338226e124a97B138Ee2ede8d965b = "home-page-posts2";

// id: "2e5caa2f-8df0-42ec-86df-0bee4ead061e"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "3479e80c-54e8-4c69-9f15-6976e741eea8"
export function Footer2e5caa2f8df042ec86df0bee4ead061e(props: any) {
  return (
    <DefaultFooter6ec2bf20Eb6e4ddbB47c00e98493a579 parentTag="Footer2e5caa2f8df042ec86df0bee4ead061e" {...props} />
  );
}

// id: "bc5d6495-4f53-44f4-a9ce-be22e1e28e07"
// title: ""
// type: :text
// key: "class"
// parent_id: "0d6b6d22-91ba-454a-9aca-f62cb30bd495"
export const ClassBc5d64954f5344f4A9ceBe22e1e28e07 = "linked-logo";

// id: "4447c32f-e617-41d8-a8bc-55461b6fb689"
// title: "About SuSun"
// type: :html
// key: "about-susan"
// parent_id: nil
export function AboutSusan4447c32fE61741d8A8bc55461b6fb689(props: any) {
  const MembersHeader = AppStore.presets["MembersHeader"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AboutSusan4447c32fE61741d8A8bc55461b6fb689`} navMenuSlug="members-primary-nav">
      {props["about-susan-header"] || <MembersHeader className="AboutSusanHeaderFbb6f087A4804b15Bbb31bf2fc5a0e28" parentTag={buildClassName("AboutSusanHeaderFbb6f087A4804b15Bbb31bf2fc5a0e28", parentTag)} {...props} />}
      {props["about-susan-main"] || <AboutSusanMain723ec82bD14744edAe433566b074a67e />}
      {props["footer"] || <DefaultFooter6ec2bf20Eb6e4ddbB47c00e98493a579 parentTag="Footer244953431e58409b895d3553f6f36718" {...props} />}
    </div>
  );
}

// id: "72577776-1829-4990-9a88-3c9e38439f51"
// title: "Home Header"
// type: :html
// key: "home-header"
// parent_id: nil
export function HomeHeader72577776182949909a883c9e38439f51(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HomeHeader72577776182949909a883c9e38439f51 site-header`}>
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTopE12a3d48D6f34063Ab0a784bda71ac02 parentTag="HeaderTop428a776eBbd342c7A510507f0ad96b05" {...props} />}
      </div>
      <div className="relative hero-wrapper">
        <div className="background-image" />
        {props["hero"] || <Hero className="HeroC622f898F16e42c4A101B5ab8e020367" parentTag={buildClassName("HeroC622f898F16e42c4A101B5ab8e020367", parentTag)} postSlug="home-hero" {...props} />}
      </div>
    </div>
  );
}

// id: "24495343-1e58-409b-895d-3553f6f36718"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "4447c32f-e617-41d8-a8bc-55461b6fb689"
export function Footer244953431e58409b895d3553f6f36718(props: any) {
  return (
    <DefaultFooter6ec2bf20Eb6e4ddbB47c00e98493a579 parentTag="Footer244953431e58409b895d3553f6f36718" {...props} />
  );
}

// id: "8a1cc72a-4333-40a8-8336-4a1b7d55d7eb"
// title: ""
// type: :text
// key: "title"
// parent_id: "cf11e3ea-5896-490f-adc8-7a353b8badca"
export const Title8a1cc72a433340a883364a1b7d55d7eb = "Default Title";

// id: "8250aac8-0424-47f8-913f-6e665945b0aa"
// title: ""
// type: :reference
// key: "header"
// parent_id: "429e88c1-5ea6-4e02-900d-7e69535861fb"
export function Header8250aac8042447f8913f6e665945b0aa(props: any) {
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  return (
    <MembersAreaHeaderOldD13a9264561d4703Beb4B4f6b4a13cf8 parentTag="Header8250aac8042447f8913f6e665945b0aa" {...props} />
  );
}

// id: "e15d6cac-c23a-48e9-a28f-bdc93b65f632"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "51433af9-b8d8-4a7b-a9e7-d77b92332383"
export const PostSlugE15d6cacC23a48e9A28fBdc93b65f632 = "about-us-posts";

// id: "59dd181f-4814-4c36-8a35-a849f2f8f89f"
// title: "Admin Pages"
// type: :html
// key: "admin-pages"
// parent_id: nil
export function AdminPages59dd181f48144c368a35A849f2f8f89f(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AdminPages59dd181f48144c368a35A849f2f8f89f`}>
      {props.children}
    </div>
  );
}

// id: "d13a9264-561d-4703-beb4-b4f6b4a13cf8"
// title: "Members Area Header"
// type: :reference
// key: "members-area-header-old"
// parent_id: nil
export function MembersAreaHeaderOldD13a9264561d4703Beb4B4f6b4a13cf8(props: any) {
  return (
    <DefaultHeaderTopE12a3d48D6f34063Ab0a784bda71ac02 parentTag="MembersAreaHeaderOldD13a9264561d4703Beb4B4f6b4a13cf8" navMenuSlug="members-primary-nav" header-top={<DefaultHeaderTopE12a3d48D6f34063Ab0a784bda71ac02 parentTag="HeaderTop9d4d72a61a784a59B5541fa6a68a6a23" navMenuSlug="members-primary-nav" />} {...props} />
  );
}

// id: "51433af9-b8d8-4a7b-a9e7-d77b92332383"
// title: ""
// type: :reference
// key: "body"
// parent_id: "6ad2bf4a-2bb1-4431-88b1-92725c364d23"
export function Body51433af9B8d84a7bA9e7D77b92332383(props: any) {
  return (
    <MarketingBody9d7fd95bC7014899B32f6c5055f77ef0 parentTag="Body51433af9B8d84a7bA9e7D77b92332383" postSlug="about-us-posts" {...props} />
  );
}

// id: "cdb383e8-cdc0-4522-9531-67dbfefbbf3c"
// title: ""
// type: :reference
// key: "marketingCards"
// parent_id: "9d7fd95b-c701-4899-b32f-6c5055f77ef0"
export function MarketingCardsCdb383e8Cdc04522953167dbfefbbf3c(props: any) {
  return (
    <MarketingCardsFcbd50009aa24693853d49c54431fb8e parentTag="MarketingCardsCdb383e8Cdc04522953167dbfefbbf3c" postSlug="home-page-posts2" {...props} />
  );
}

// id: "963b7d89-8a4c-4191-ba08-72de89bede25"
// title: ""
// type: :text
// key: "class"
// parent_id: "2ccb86c1-80e5-4426-ad04-ebad5b654e89"
export const Class963b7d898a4c4191Ba0872de89bede25 = "navigation";

// id: "c30d59ab-16df-4867-89df-f4c3d752cd09"
// title: ""
// type: :text
// key: "title"
// parent_id: "451857c0-22c1-4ab6-99ee-2b3ca1dc8661"
export const TitleC30d59ab16df486789dfF4c3d752cd09 = "Public Events";

// id: "dd301871-3284-4b9e-9716-cad73e7b98a4"
// title: "Home Page Hero"
// type: :html
// key: "home-page-hero"
// parent_id: nil
export function HomePageHeroDd30187132844b9e9716Cad73e7b98a4(props: any) {
  const Button = AppStore.presets["Button"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HomePageHeroDd30187132844b9e9716Cad73e7b98a4 hero`}>
      <div className="title">
        Remember you are the Magic
      </div>
      <div className="button">
        {props["button"] || <Button className="Button103d08a861f84a008c459e6ba31711bd" parentTag={buildClassName("Button103d08a861f84a008c459e6ba31711bd", parentTag)} label="Join Us" href="/join" {...props} />}
      </div>
    </div>
  );
}

// id: "1357ecd9-a9f5-446a-813d-18b00b585614"
// title: "Message Pages"
// type: :html
// key: "message-pages-old"
// parent_id: nil
export function MessagePagesOld1357ecd9A9f5446a813d18b00b585614(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} MessagePagesOld1357ecd9A9f5446a813d18b00b585614`}>
      {props["header"] || <MembersAreaHeaderOldD13a9264561d4703Beb4B4f6b4a13cf8 parentTag="HeaderB2a76230591f4dec9d8c4cbfc66badd3" {...props} />}
      {props.children}
    </div>
  );
}

// id: "66647cb8-2b28-4552-bf7d-d1e2db9947af"
// title: ""
// type: :gf_preset
// key: "welcome-back"
// parent_id: "e9514198-4473-4786-970e-57e4d9d0f1c5"
export function WelcomeBack66647cb82b284552Bf7dD1e2db9947af(props: any) {
  const WelcomeBackPopUp = AppStore.presets["WelcomeBackPopUp"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <WelcomeBackPopUp className="WelcomeBack66647cb82b284552Bf7dD1e2db9947af" parentTag={buildClassName("WelcomeBack66647cb82b284552Bf7dD1e2db9947af", parentTag)} {...props} />
  );
}

// id: "e26e3066-2836-4a1d-a8f1-0e6b776b597e"
// title: ""
// type: :reference
// key: "hero"
// parent_id: "0f2a2c8d-6091-4b5c-b31c-7e70ef5c119b"
export function HeroE26e306628364a1dA8f10e6b776b597e(props: any) {
  return (
    <SecondaryMarketingHeroCf11e3ea5896490fAdc87a353b8badca parentTag="HeroE26e306628364a1dA8f10e6b776b597e" title="Secondary Marketing Title 2" {...props} />
  );
}

// id: "aa82de70-11b1-451b-92df-a05ab0e54587"
// title: ""
// type: :text
// key: "title"
// parent_id: "3166f770-21da-41bb-a4dc-9380e15e6290"
export const TitleAa82de7011b1451b92dfA05ab0e54587 = "Resources";

// id: "d8f4a9b3-2dde-4e8b-b6a5-0a54a97fde65"
// title: ""
// type: :text
// key: "label"
// parent_id: "103d08a8-61f8-4a00-8c45-9e6ba31711bd"
export const LabelD8f4a9b32dde4e8bB6a50a54a97fde65 = "Join Us";

// id: "3479e80c-54e8-4c69-9f15-6976e741eea8"
// title: "Offerings"
// type: :html
// key: "about-offerings"
// parent_id: nil
export function AboutOfferings3479e80c54e84c699f156976e741eea8(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AboutOfferings3479e80c54e84c699f156976e741eea8`}>
      {props["about-susan-header"] || <MembersAreaHeaderOldD13a9264561d4703Beb4B4f6b4a13cf8 parentTag="AboutSusanHeader7160c8de4d254fbfB0030ef23b0b7e17" {...props} />}
      <main>
        <div>
          <div className="gf-cols-2 content-width">
            <div className="image">
              <img src="https://mp1md-pub.s3.amazonaws.com/orgs/tastesoftantra/images/altar.webp" alt="Altar" className="block-image" />
            </div>
            <div className="text-block-vertical">
              <div className="heading">
                What to expect from a session
              </div>
              <ul>
                <li>
                  Reduced stress and anxiety
                </li>
                <li>
                  Increased energetic awareness
                </li>
                <li>
                  Develop more compassion for yourself and others
                </li>
                <li>
                  More capacity to live the life of your dreams
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="hero brave">
          <div className="text-block text-block-vertical content-width">
            <div className="heading">
              You&#39;re so brave for showing up!
            </div>
            <p>
              Humans come to me for a variety of different reasons. Healing is a
              very unique journey for everyone. I want to highlight my different
              offerings, yet create space to co-create something perfect for you.
            </p>
          </div>
        </div>
        <div>
          <div className="grid-blocks content-width">
            <div className="image-text-block">
              <div className="image">
                <img src="https://mp1md-pub.s3.amazonaws.com/orgs/tastesoftantra/images/susan-massage.webp" alt="SuSun massage" />
              </div>
              <div className="text">
                <div className="heading">
                  Tantric Awakening
                </div>
                <p>
                  Feel more in your body.
                </p>
                <p>
                  More pleasure. More space. More freedom.
                </p>
                <p>
                  Allow yourself to relax, receive, and enjoy.
                </p>
              </div>
            </div>
            <div className="image-text-block">
              <div className="image">
                <img src="https://mp1md-pub.s3.amazonaws.com/orgs/tastesoftantra/images/pray-art.webp" alt="Chakra" />
              </div>
              <div className="text">
                <div className="heading">
                  Chakra Alignment
                </div>
                <p>
                  Clear out stagnant energy, quiet the noise.
                </p>
                <p>
                  Through Reiki we can prepare your energetic body for a vibrational
                  shift.
                </p>
                <p>
                  Increased intuitive awareness and psychic sensitivity.
                </p>
              </div>
            </div>
            <div className="image-text-block">
              <div className="image">
                <img src="https://mp1md-pub.s3.amazonaws.com/orgs/tastesoftantra/images/sacred-foot.webp" alt="Kinky Tasting" />
              </div>
              <div className="text">
                <div className="heading">
                  Kinky Tasting
                </div>
                <p>
                  Do you have an itch to explore?
                </p>
                <p>
                  Something you have always wanted to try?
                </p>
                <p>
                  Let&#39;s get a taste of those passions you may be a bit shy to talk
                  about.
                </p>
                <p>
                  Through consent, negotiation and boundaries we can explore in new
                  ways.
                </p>
              </div>
            </div>
            <div className="image-text-block">
              <div className="image">
                <img src="https://mp1md-pub.s3.amazonaws.com/orgs/tastesoftantra/images/susan-guiding.webp" alt="SuSun guiding a student" />
              </div>
              <div className="text">
                <div className="heading">
                  Becoming Sex-Positive
                </div>
                <p>
                  Build your communication skills, knowledge and understanding.
                </p>
                <p>
                  Learn your somatic YES, body awareness and the confidence to bring
                  all of yourself into community.
                </p>
                <p>
                  Take a road trip into new and exciting ways of being in
                  relationship.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div>
          <a href="/members/messages/x1RwUD7TogtZzODN" className="Button">
            Walking with me
          </a>
        </div>
      </main>
      {props["footer"] || <DefaultFooter6ec2bf20Eb6e4ddbB47c00e98493a579 parentTag="Footer2e5caa2f8df042ec86df0bee4ead061e" {...props} />}
    </div>
  );
}

// id: "02923805-1324-4226-8e02-d83ef87c1ebe"
// title: ""
// type: :html
// key: "logo"
// parent_id: "6ec2bf20-eb6e-4ddb-b47c-00e98493a579"
export function Logo02923805132442268e02D83ef87c1ebe(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <img src="https://mp1md-pub.s3.amazonaws.com/orgs/tastesoftantra/logo-wide-white.svg" alt="Demo 1 logo" className={`${parentTag || ""} Logo02923805132442268e02D83ef87c1ebe logo`} />
  );
}

// id: "a283fb68-952d-434c-b91c-6c9b63d94831"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "76363eef-eb7b-4818-a5bc-e43ae90f6286"
export function FooterA283fb68952d434cB91c6c9b63d94831(props: any) {
  return (
    <DefaultFooter6ec2bf20Eb6e4ddbB47c00e98493a579 parentTag="FooterA283fb68952d434cB91c6c9b63d94831" {...props} />
  );
}

// id: "3a9c0bca-8607-4a72-93de-bbc97b3fe438"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "116ea88f-0237-4ebc-9201-b97a136709e4"
export function Footer3a9c0bca86074a7293deBbc97b3fe438(props: any) {
  return (
    <DefaultFooter6ec2bf20Eb6e4ddbB47c00e98493a579 parentTag="Footer3a9c0bca86074a7293deBbc97b3fe438" {...props} />
  );
}

// id: "77a459f5-14ac-4b62-9fa1-977f5eb0c076"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "12e1f405-7eec-4a60-baf3-a6c3e00acd79"
export const ContentSlug77a459f514ac4b629fa1977f5eb0c076 = "home-page-quote";

// id: "114ab35c-acb4-4417-b83a-e8ee7d8a6369"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "a742946d-ff44-4d1c-905e-9d124516e6e1"
export const NavMenuSlug114ab35cAcb44417B83aE8ee7d8a6369 = "footer-nav";

// id: "0f2a2c8d-6091-4b5c-b31c-7e70ef5c119b"
// title: "Secondary Marketing Header"
// type: :html
// key: "secondary-marketing-header"
// parent_id: nil
export function SecondaryMarketingHeader0f2a2c8d60914b5cB31c7e70ef5c119b(props: any) {
  const { parentTag, ...rest } = props;
  props = { title: "Secondary Marketing Title 1", ...rest };
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHeader0f2a2c8d60914b5cB31c7e70ef5c119b site-header`}>
      <div className="background-image" />
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTopE12a3d48D6f34063Ab0a784bda71ac02 parentTag="HeaderTop3641096766674771880c30a6fed47fef" {...props} />}
      </div>
      {props["hero"] || <SecondaryMarketingHeroCf11e3ea5896490fAdc87a353b8badca parentTag="HeroE26e306628364a1dA8f10e6b776b597e" title="Secondary Marketing Title 2" {...props} />}
    </div>
  );
}

// id: "cbcc347c-cb8e-417e-9862-a43cd5b47767"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "d13a9264-561d-4703-beb4-b4f6b4a13cf8"
export const NavMenuSlugCbcc347cCb8e417e9862A43cd5b47767 = "members-primary-nav";

// id: "36410967-6667-4771-880c-30a6fed47fef"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "0f2a2c8d-6091-4b5c-b31c-7e70ef5c119b"
export function HeaderTop3641096766674771880c30a6fed47fef(props: any) {
  return (
    <DefaultHeaderTopE12a3d48D6f34063Ab0a784bda71ac02 parentTag="HeaderTop3641096766674771880c30a6fed47fef" {...props} />
  );
}

// id: "02e5eef5-238e-4fc8-9ac8-4f0586d940f0"
// title: ""
// type: :reference
// key: "body"
// parent_id: "e9514198-4473-4786-970e-57e4d9d0f1c5"
export function Body02e5eef5238e4fc89ac84f0586d940f0(props: any) {
  return (
    <MarketingBody9d7fd95bC7014899B32f6c5055f77ef0 parentTag="Body02e5eef5238e4fc89ac84f0586d940f0" {...props} />
  );
}

// id: "346f64d3-e56b-4a8b-9da0-16943b430b61"
// title: ""
// type: :text
// key: "url"
// parent_id: "0d6b6d22-91ba-454a-9aca-f62cb30bd495"
export const Url346f64d3E56b4a8b9da016943b430b61 = "/";

// id: "96c54739-8b72-4a52-976c-8474e73738c3"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "98e96486-9dc7-41a0-9b51-eb9f7b18ff34"
export const NavMenuSlug96c547398b724a52976c8474e73738c3 = "members-primary-nav";

// id: "6ced6757-8fac-4360-9a15-84268d702014"
// title: "Join Us Page"
// type: :reference
// key: "join-us-page"
// parent_id: nil
export function JoinUsPage6ced67578fac43609a1584268d702014(props: any) {
  return (
    <SecondaryPage2443939a735146eaBf30C09d2d282a72 parentTag="JoinUsPage6ced67578fac43609a1584268d702014" className="join-us" header={<SecondaryMarketingHeader0f2a2c8d60914b5cB31c7e70ef5c119b parentTag="HeaderA3b5d3b3263c42f0829e145f7c1993fc" title="Join Us" />} {...props} />
  );
}

// id: "4e208243-1f9e-4e7e-aefc-5ff989662083"
// title: ""
// type: :reference
// key: "header"
// parent_id: "e9514198-4473-4786-970e-57e4d9d0f1c5"
export function Header4e2082431f9e4e7eAefc5ff989662083(props: any) {
  return (
    <HomeHeader72577776182949909a883c9e38439f51 parentTag="Header4e2082431f9e4e7eAefc5ff989662083" {...props} />
  );
}

// id: "5bfd5525-011b-441c-93aa-30acc33ae133"
// title: ""
// type: :gf_preset
// key: "linked-logo"
// parent_id: "3627fd16-af04-4889-9796-8dabaf6a453f"
export function LinkedLogo5bfd5525011b441c93aa30acc33ae133(props: any) {
  const Link = AppStore.presets["Link"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Link className="LinkedLogo5bfd5525011b441c93aa30acc33ae133" parentTag={buildClassName("LinkedLogo5bfd5525011b441c93aa30acc33ae133", parentTag)} label={<DefaultLogo82b71e1994ac4b17B3769936194f836c parentTag="Label9191784288574d8994011812cab76b85" alt="logo" />} {...props} />
  );
}

// id: "451857c0-22c1-4ab6-99ee-2b3ca1dc8661"
// title: ""
// type: :reference
// key: "header"
// parent_id: "116ea88f-0237-4ebc-9201-b97a136709e4"
export function Header451857c022c14ab699ee2b3ca1dc8661(props: any) {
  return (
    <SecondaryMarketingHeader0f2a2c8d60914b5cB31c7e70ef5c119b parentTag="Header451857c022c14ab699ee2b3ca1dc8661" title="Public Events" {...props} />
  );
}

// id: "4ab166ed-3983-4753-ab13-c066a7824a0a"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "647a6881-32f9-45a5-8d2d-8d6a685ffc10"
export const NavMenuSlug4ab166ed39834753Ab13C066a7824a0a = "members-primary-nav";

// id: "8317afae-f135-4348-994d-692ca45e57cb"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "9d4d72a6-1a78-4a59-b554-1fa6a68a6a23"
export const NavMenuSlug8317afaeF1354348994d692ca45e57cb = "members-primary-nav";

// id: "6ad2bf4a-2bb1-4431-88b1-92725c364d23"
// title: "About Us"
// type: :html
// key: "about-us-page"
// parent_id: nil
export function AboutUsPage6ad2bf4a2bb1443188b192725c364d23(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AboutUsPage6ad2bf4a2bb1443188b192725c364d23 page`}>
      {props["header"] || <SecondaryMarketingHeader0f2a2c8d60914b5cB31c7e70ef5c119b parentTag="Header225006e40cb9469a8991E571ab647a5f" title="About Susan" {...props} />}
      <main className="main">
        About Susan - TBD
      </main>
      {props["footer"] || <DefaultFooter6ec2bf20Eb6e4ddbB47c00e98493a579 parentTag="Footer9dac4e2bC13f4c2fA72eA80b68874e4b" {...props} />}
    </div>
  );
}

// id: "12e1f405-7eec-4a60-baf3-a6c3e00acd79"
// title: ""
// type: :gf_preset
// key: "quote"
// parent_id: "e9514198-4473-4786-970e-57e4d9d0f1c5"
export function Quote12e1f4057eec4a60Baf3A6c3e00acd79(props: any) {
  const PageQuote = AppStore.presets["PageQuote"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageQuote className="Quote12e1f4057eec4a60Baf3A6c3e00acd79" parentTag={buildClassName("Quote12e1f4057eec4a60Baf3A6c3e00acd79", parentTag)} contentSlug="home-page-quote" {...props} />
  );
}

// id: "9d4d72a6-1a78-4a59-b554-1fa6a68a6a23"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "d13a9264-561d-4703-beb4-b4f6b4a13cf8"
export function HeaderTop9d4d72a61a784a59B5541fa6a68a6a23(props: any) {
  return (
    <DefaultHeaderTopE12a3d48D6f34063Ab0a784bda71ac02 parentTag="HeaderTop9d4d72a61a784a59B5541fa6a68a6a23" navMenuSlug="members-primary-nav" {...props} />
  );
}

// id: "48432081-5230-493f-a949-01a50c0aa84d"
// title: ""
// type: :text
// key: "title"
// parent_id: "e26e3066-2836-4a1d-a8f1-0e6b776b597e"
export const Title484320815230493fA94901a50c0aa84d = "Secondary Marketing Title 2";

// id: "619cdfb9-a3f9-4802-878b-28519c68461b"
// title: ""
// type: :text
// key: "class"
// parent_id: "4185be57-e156-44ca-8363-4a0574bf18f5"
export const Class619cdfb9A3f94802878b28519c68461b = "navigation";

// id: "10c5fefc-c4b1-4cd1-b027-bff26d296e3b"
// title: "Page Quote"
// type: :html
// key: "page-quote"
// parent_id: nil
export function PageQuote10c5fefcC4b14cd1B027Bff26d296e3b(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PageQuote10c5fefcC4b14cd1B027Bff26d296e3b`}>
      <div>
      </div>
      <div>
      </div>
    </div>
  );
}

// id: "3b9bbbf4-b6e0-4761-929c-b306f732ab8e"
// title: ""
// type: :text
// key: "backgroundImage"
// parent_id: "3627fd16-af04-4889-9796-8dabaf6a453f"
export const BackgroundImage3b9bbbf4B6e04761929cB306f732ab8e = "https://mp1md-pub.s3.amazonaws.com/orgs/sample/city-background.jpg";

// id: "072f23d3-6e5e-4840-bc94-9e9f8be02355"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "cb3923a0-602d-43e3-b227-3ddee5ba8381"
export function Footer072f23d36e5e4840Bc949e9f8be02355(props: any) {
  return (
    <DefaultFooter6ec2bf20Eb6e4ddbB47c00e98493a579 parentTag="Footer072f23d36e5e4840Bc949e9f8be02355" {...props} />
  );
}

// id: "c1f37003-9351-4bea-a54b-12d6d01610d3"
// title: ""
// type: :text
// key: "buttonClass"
// parent_id: "fcbd5000-9aa2-4693-853d-49c54431fb8e"
export const ButtonClassC1f3700393514beaA54b12d6d01610d3 = "inline-block px-12 py-3 hover:brightness-110 transition duration";

// id: "7e4d5853-61cb-42c6-a811-dd14975e48cd"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "c622f898-f16e-42c4-a101-b5ab8e020367"
export const PostSlug7e4d585361cb42c6A811Dd14975e48cd = "home-hero";

// id: "3627fd16-af04-4889-9796-8dabaf6a453f"
// title: "Short Header"
// type: :html
// key: "short-header"
// parent_id: nil
export function ShortHeader3627fd16Af04488997968dabaf6a453f(props: any) {
  const Link = AppStore.presets["Link"];
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} ShortHeader3627fd16Af04488997968dabaf6a453f site-header`}>
      <div className="background-image" />
      <div className="header-top">
        {props["linked-logo"] || <Link className="LinkedLogo5bfd5525011b441c93aa30acc33ae133" parentTag={buildClassName("LinkedLogo5bfd5525011b441c93aa30acc33ae133", parentTag)} label={<DefaultLogo82b71e1994ac4b17B3769936194f836c parentTag="Label9191784288574d8994011812cab76b85" alt="logo" />} {...props} />}
        {props["navigation"] || <PrimaryNavigation className="Navigation647a688132f945a58d2d8d6a685ffc10" parentTag={buildClassName("Navigation647a688132f945a58d2d8d6a685ffc10", parentTag)} navMenuSlug="members-primary-nav" {...props} />}
      </div>
    </div>
  );
}

// id: "ea9c8f0a-024d-4315-a871-74fc40752dda"
// title: ""
// type: :text
// key: "imageUrl"
// parent_id: "82b71e19-94ac-4b17-b376-9936194f836c"
export const ImageUrlEa9c8f0a024d4315A87174fc40752dda = "https://mp1md-pub.s3.amazonaws.com/orgs/tastesoftantra/logo-wide-white.svg";

// id: "225006e4-0cb9-469a-8991-e571ab647a5f"
// title: ""
// type: :reference
// key: "header"
// parent_id: "6ad2bf4a-2bb1-4431-88b1-92725c364d23"
export function Header225006e40cb9469a8991E571ab647a5f(props: any) {
  return (
    <SecondaryMarketingHeader0f2a2c8d60914b5cB31c7e70ef5c119b parentTag="Header225006e40cb9469a8991E571ab647a5f" title="About Susan" {...props} />
  );
}

// id: "1b42632b-5b12-4a5d-890a-d2ccfd12dcf8"
// title: ""
// type: :gf_preset
// key: "copyright"
// parent_id: "6ec2bf20-eb6e-4ddb-b47c-00e98493a579"
export function Copyright1b42632b5b124a5d890aD2ccfd12dcf8(props: any) {
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupCopyright className="Copyright1b42632b5b124a5d890aD2ccfd12dcf8" parentTag={buildClassName("Copyright1b42632b5b124a5d890aD2ccfd12dcf8", parentTag)} {...props} />
  );
}

// id: "bedb7d3b-7fc1-4497-9000-54998bf4e873"
// title: ""
// type: :text
// key: "href"
// parent_id: "103d08a8-61f8-4a00-8c45-9e6ba31711bd"
export const HrefBedb7d3b7fc14497900054998bf4e873 = "/join";

// id: "2443939a-7351-46ea-bf30-c09d2d282a72"
// title: "Secondary Page"
// type: :html
// key: "secondary-page"
// parent_id: nil
export function SecondaryPage2443939a735146eaBf30C09d2d282a72(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryPage2443939a735146eaBf30C09d2d282a72 gf-page-layout`}>
      {props["header"] || <SecondaryMarketingHeader0f2a2c8d60914b5cB31c7e70ef5c119b parentTag="HeaderDe48a21eEb3d40c69d3eE5d9365c83df" title="Secondary Page" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooter6ec2bf20Eb6e4ddbB47c00e98493a579 parentTag="FooterA807bce1De4c42108198185446bd8740" {...props} />}
    </div>
  );
}

// id: "fbb6f087-a480-4b15-bbb3-1bf2fc5a0e28"
// title: ""
// type: :gf_preset
// key: "about-susan-header"
// parent_id: "4447c32f-e617-41d8-a8bc-55461b6fb689"
export function AboutSusanHeaderFbb6f087A4804b15Bbb31bf2fc5a0e28(props: any) {
  const MembersHeader = AppStore.presets["MembersHeader"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MembersHeader className="AboutSusanHeaderFbb6f087A4804b15Bbb31bf2fc5a0e28" parentTag={buildClassName("AboutSusanHeaderFbb6f087A4804b15Bbb31bf2fc5a0e28", parentTag)} {...props} />
  );
}

// id: "be4c9977-9a7d-444a-af40-9b9d3ef03249"
// title: "Header Top"
// type: :reference
// key: "header-top"
// parent_id: "4447c32f-e617-41d8-a8bc-55461b6fb689"
export function HeaderTopBe4c99779a7d444aAf409b9d3ef03249(props: any) {
  return (
    <DefaultHeaderTopE12a3d48D6f34063Ab0a784bda71ac02 parentTag="HeaderTopBe4c99779a7d444aAf409b9d3ef03249" {...props} />
  );
}

// id: "a3b5d3b3-263c-42f0-829e-145f7c1993fc"
// title: ""
// type: :reference
// key: "header"
// parent_id: "6ced6757-8fac-4360-9a15-84268d702014"
export function HeaderA3b5d3b3263c42f0829e145f7c1993fc(props: any) {
  return (
    <SecondaryMarketingHeader0f2a2c8d60914b5cB31c7e70ef5c119b parentTag="HeaderA3b5d3b3263c42f0829e145f7c1993fc" title="Join Us" {...props} />
  );
}

// id: "8c68c320-80ef-4a82-acbe-cd29d7196ee3"
// title: ""
// type: :text
// key: "title"
// parent_id: "a3b5d3b3-263c-42f0-829e-145f7c1993fc"
export const Title8c68c32080ef4a82AcbeCd29d7196ee3 = "Join Us";

// id: "fcbd5000-9aa2-4693-853d-49c54431fb8e"
// title: "Marketing Cards"
// type: :gf_preset
// key: "marketing-cards"
// parent_id: nil
export function MarketingCardsFcbd50009aa24693853d49c54431fb8e(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="MarketingCardsFcbd50009aa24693853d49c54431fb8e" parentTag={buildClassName("MarketingCardsFcbd50009aa24693853d49c54431fb8e", parentTag)} postSlug="home-page-posts2" buttonClass="inline-block px-12 py-3 hover:brightness-110 transition duration" {...props} />
  );
}

// id: "0d6b6d22-91ba-454a-9aca-f62cb30bd495"
// title: ""
// type: :gf_preset
// key: "linked-logo"
// parent_id: "e12a3d48-d6f3-4063-ab0a-784bda71ac02"
export function LinkedLogo0d6b6d2291ba454a9acaF62cb30bd495(props: any) {
  const Link = AppStore.presets["Link"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Link className="LinkedLogo0d6b6d2291ba454a9acaF62cb30bd495" parentTag={buildClassName("LinkedLogo0d6b6d2291ba454a9acaF62cb30bd495", parentTag)} label={<DefaultLogo82b71e1994ac4b17B3769936194f836c parentTag="Label2bf815f2Bfea44c99858938b19d94a63" alt="logo" />} className="linked-logo" url="/" {...props} />
  );
}

// id: "b2a76230-591f-4dec-9d8c-4cbfc66badd3"
// title: ""
// type: :reference
// key: "header"
// parent_id: "1357ecd9-a9f5-446a-813d-18b00b585614"
export function HeaderB2a76230591f4dec9d8c4cbfc66badd3(props: any) {
  return (
    <MembersAreaHeaderOldD13a9264561d4703Beb4B4f6b4a13cf8 parentTag="HeaderB2a76230591f4dec9d8c4cbfc66badd3" {...props} />
  );
}

// id: "2ccb86c1-80e5-4426-ad04-ebad5b654e89"
// title: ""
// type: :gf_preset
// key: "navigation"
// parent_id: "e12a3d48-d6f3-4063-ab0a-784bda71ac02"
export function Navigation2ccb86c180e54426Ad04Ebad5b654e89(props: any) {
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PrimaryNavigation className="Navigation2ccb86c180e54426Ad04Ebad5b654e89" parentTag={buildClassName("Navigation2ccb86c180e54426Ad04Ebad5b654e89", parentTag)} className="navigation" navMenuSlug="marketing-primary-nav" {...props} />
  );
}

// id: "6ee0a292-a73e-485e-abc6-899a0a5f47be"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "cdb383e8-cdc0-4522-9531-67dbfefbbf3c"
export const PostSlug6ee0a292A73e485eAbc6899a0a5f47be = "home-page-posts2";

// id: "e29fb134-7e53-41b3-bd13-ef4a841f88ee"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "e9514198-4473-4786-970e-57e4d9d0f1c5"
export function FooterE29fb1347e5341b3Bd13Ef4a841f88ee(props: any) {
  return (
    <DefaultFooter6ec2bf20Eb6e4ddbB47c00e98493a579 parentTag="FooterE29fb1347e5341b3Bd13Ef4a841f88ee" {...props} />
  );
}

// id: "17604eba-9c67-4661-95c0-82cf6ea9a45d"
// title: ""
// type: :text
// key: "title"
// parent_id: "b16c6ac4-5d59-4853-bfa6-a66fb970deaf"
export const Title17604eba9c67466195c082cf6ea9a45d = "Apply";

// id: "617b9830-408f-4341-a268-81db0b3fc07e"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "2ccb86c1-80e5-4426-ad04-ebad5b654e89"
export const NavMenuSlug617b9830408f4341A26881db0b3fc07e = "marketing-primary-nav";

// id: "ae3b02e6-1854-4ca9-9ed0-2a4f14a678c4"
// title: "Marketing Primary Navigation"
// type: :text
// key: "navMenuSlug"
// parent_id: "b16c6ac4-5d59-4853-bfa6-a66fb970deaf"
export const NavMenuSlugAe3b02e618544ca99ed02a4f14a678c4 = "marketing-primary-nav";

// id: "4185be57-e156-44ca-8363-4a0574bf18f5"
// title: "Members Area Navigation"
// type: :gf_preset
// key: "navigation"
// parent_id: "8250aac8-0424-47f8-913f-6e665945b0aa"
export function Navigation4185be57E15644ca83634a0574bf18f5(props: any) {
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PrimaryNavigation className="Navigation4185be57E15644ca83634a0574bf18f5" parentTag={buildClassName("Navigation4185be57E15644ca83634a0574bf18f5", parentTag)} className="navigation" {...props} />
  );
}

const Components = {
  Header20bd56bf02474c6aA2ef8853a77ccd48,
  ResourcesPageAe3e5461B3d246f2Bc5b2a0a85c53e8c,
  Footer7c5584b490ad41b090c4F9b144bbfae5,
  Alt8ddcd4ed8811418a9b0fF9b1f77fd202,
  AboutSusanMain723ec82bD14744edAe433566b074a67e,
  TitleB6d1a0ffEc4c4a44B8949690c79ee760,
  Href635159c1C0c844b6B072936875fbe716,
  Title8089b3d797d54dab8b16B98321436fc7,
  HeroC622f898F16e42c4A101B5ab8e020367,
  NavMenuSlug9b1d7d29Bb904b57B215920289cea259,
  AboutSusanHeader7160c8de4d254fbfB0030ef23b0b7e17,
  TitleAb0d78f400ed4042B0f36ce3365d73b0,
  MemberPagesOld429e88c15ea64e02900d7e69535861fb,
  HomePageE951419844734786970e57e4d9d0f1c5,
  HeaderBa92426cD60147cb94672a78b69c6788,
  SecondaryNavCf21560b19404d58Bc744da88ab2bfdb,
  Header98e964869dc741a09b51Eb9f7b18ff34,
  Label9191784288574d8994011812cab76b85,
  DefaultHeaderTopE12a3d48D6f34063Ab0a784bda71ac02,
  DefaultHeaderB16c6ac45d594853Bfa6A66fb970deaf,
  Button103d08a861f84a008c459e6ba31711bd,
  BackgroundImage7ac2223e518d42cdA9c3D95cacbe397b,
  Footer9dac4e2bC13f4c2fA72eA80b68874e4b,
  TitleF057e8f13d694095A05fA217a15f6aef,
  MarketingBody9d7fd95bC7014899B32f6c5055f77ef0,
  LabelE5b93beb7dc3424799da708903df58df,
  Navigation647a688132f945a58d2d8d6a685ffc10,
  AboutLevelingPageCb3923a0602d43e3B2273ddee5ba8381,
  DefaultLogo82b71e1994ac4b17B3769936194f836c,
  FooterA807bce1De4c42108198185446bd8740,
  Groupflow8578c32764794b2eBea8B40628b6583a,
  ClassA714ee5778ab4ebc8687A7a49cdb1dc6,
  Title75b55a1cA8754698Ab6aB76a77fa3466,
  SignupPagesBce3bc00525c44e9936c3160ca9411f1,
  Footer9eae99eb0aa0482cA8c62a7099f61960,
  HeaderTop428a776eBbd342c7A510507f0ad96b05,
  Header3166f77021da41bbA4dc9380e15e6290,
  HeaderDe48a21eEb3d40c69d3eE5d9365c83df,
  Label2bf815f2Bfea44c99858938b19d94a63,
  PublicEventsPage116ea88f02374ebc9201B97a136709e4,
  MembersAreaDefault76363eefEb7b4818A5bcE43ae90f6286,
  HeaderD59d85b2C27947d2Be7eC4e84231ab7b,
  LinksA742946dFf444d1c905e9d124516e6e1,
  SecondaryMarketingHeroCf11e3ea5896490fAdc87a353b8badca,
  DefaultFooter6ec2bf20Eb6e4ddbB47c00e98493a579,
  TitleF2c06cfa4c78406cAd51E4449fa6213a,
  PostSlug96a338226e124a97B138Ee2ede8d965b,
  Footer2e5caa2f8df042ec86df0bee4ead061e,
  ClassBc5d64954f5344f4A9ceBe22e1e28e07,
  AboutSusan4447c32fE61741d8A8bc55461b6fb689,
  HomeHeader72577776182949909a883c9e38439f51,
  Footer244953431e58409b895d3553f6f36718,
  Title8a1cc72a433340a883364a1b7d55d7eb,
  Header8250aac8042447f8913f6e665945b0aa,
  PostSlugE15d6cacC23a48e9A28fBdc93b65f632,
  AdminPages59dd181f48144c368a35A849f2f8f89f,
  MembersAreaHeaderOldD13a9264561d4703Beb4B4f6b4a13cf8,
  Body51433af9B8d84a7bA9e7D77b92332383,
  MarketingCardsCdb383e8Cdc04522953167dbfefbbf3c,
  Class963b7d898a4c4191Ba0872de89bede25,
  TitleC30d59ab16df486789dfF4c3d752cd09,
  HomePageHeroDd30187132844b9e9716Cad73e7b98a4,
  MessagePagesOld1357ecd9A9f5446a813d18b00b585614,
  WelcomeBack66647cb82b284552Bf7dD1e2db9947af,
  HeroE26e306628364a1dA8f10e6b776b597e,
  TitleAa82de7011b1451b92dfA05ab0e54587,
  LabelD8f4a9b32dde4e8bB6a50a54a97fde65,
  AboutOfferings3479e80c54e84c699f156976e741eea8,
  Logo02923805132442268e02D83ef87c1ebe,
  FooterA283fb68952d434cB91c6c9b63d94831,
  Footer3a9c0bca86074a7293deBbc97b3fe438,
  ContentSlug77a459f514ac4b629fa1977f5eb0c076,
  NavMenuSlug114ab35cAcb44417B83aE8ee7d8a6369,
  SecondaryMarketingHeader0f2a2c8d60914b5cB31c7e70ef5c119b,
  NavMenuSlugCbcc347cCb8e417e9862A43cd5b47767,
  HeaderTop3641096766674771880c30a6fed47fef,
  Body02e5eef5238e4fc89ac84f0586d940f0,
  Url346f64d3E56b4a8b9da016943b430b61,
  NavMenuSlug96c547398b724a52976c8474e73738c3,
  JoinUsPage6ced67578fac43609a1584268d702014,
  Header4e2082431f9e4e7eAefc5ff989662083,
  LinkedLogo5bfd5525011b441c93aa30acc33ae133,
  Header451857c022c14ab699ee2b3ca1dc8661,
  NavMenuSlug4ab166ed39834753Ab13C066a7824a0a,
  NavMenuSlug8317afaeF1354348994d692ca45e57cb,
  AboutUsPage6ad2bf4a2bb1443188b192725c364d23,
  Quote12e1f4057eec4a60Baf3A6c3e00acd79,
  HeaderTop9d4d72a61a784a59B5541fa6a68a6a23,
  Title484320815230493fA94901a50c0aa84d,
  Class619cdfb9A3f94802878b28519c68461b,
  PageQuote10c5fefcC4b14cd1B027Bff26d296e3b,
  BackgroundImage3b9bbbf4B6e04761929cB306f732ab8e,
  Footer072f23d36e5e4840Bc949e9f8be02355,
  ButtonClassC1f3700393514beaA54b12d6d01610d3,
  PostSlug7e4d585361cb42c6A811Dd14975e48cd,
  ShortHeader3627fd16Af04488997968dabaf6a453f,
  ImageUrlEa9c8f0a024d4315A87174fc40752dda,
  Header225006e40cb9469a8991E571ab647a5f,
  Copyright1b42632b5b124a5d890aD2ccfd12dcf8,
  HrefBedb7d3b7fc14497900054998bf4e873,
  SecondaryPage2443939a735146eaBf30C09d2d282a72,
  AboutSusanHeaderFbb6f087A4804b15Bbb31bf2fc5a0e28,
  HeaderTopBe4c99779a7d444aAf409b9d3ef03249,
  HeaderA3b5d3b3263c42f0829e145f7c1993fc,
  Title8c68c32080ef4a82AcbeCd29d7196ee3,
  MarketingCardsFcbd50009aa24693853d49c54431fb8e,
  LinkedLogo0d6b6d2291ba454a9acaF62cb30bd495,
  HeaderB2a76230591f4dec9d8c4cbfc66badd3,
  Navigation2ccb86c180e54426Ad04Ebad5b654e89,
  PostSlug6ee0a292A73e485eAbc6899a0a5f47be,
  FooterE29fb1347e5341b3Bd13Ef4a841f88ee,
  Title17604eba9c67466195c082cf6ea9a45d,
  NavMenuSlug617b9830408f4341A26881db0b3fc07e,
  NavMenuSlugAe3b02e618544ca99ed02a4f14a678c4,
  Navigation4185be57E15644ca83634a0574bf18f5
}

export default Components;